<header *ngIf="router.url !== '/login' && router.url !== '/register'">
  <app-navbar></app-navbar>
</header>
<main>
  <!-- <div *ngIf="userLoaded"> -->
  <router-outlet></router-outlet>
  <!-- </div> -->
</main>
<app-footer
  *ngIf="router.url !== '/login' && router.url !== '/register'"
></app-footer>
